import {ReactNode} from "react";
import classNames from "classnames";

interface HeadingProps {
  size?: "sm" | "md" | "lg"
  className?: string;
  children: ReactNode;
}

export const Heading = ({
  children,
  className,
  size = "md",
}: HeadingProps) => {
  let style = "";

  switch (size) {
  case "sm":
    style = "text-lg md:text-2xl";
    break;
  case "md":
    style = "text-xl md:text-3xl";
    break;
  case "lg":
    style = "text-2xl md:text-4xl";
    break;
  }

  return (
    <span className={classNames(className, style, "font-unleashed")}>
      {children}
    </span>
  );
};
